import React, { useState } from "react";
import Modal from "../../../components/Modal";

const CANCELLATION_REASONS = [
  { value: "Cancelled by Parent", tutorCancelled: false },
  { value: "Cancelled by Tutor", tutorCancelled: true },
  { value: "No response by Tutor", tutorCancelled: true },
  { value: "No response by Parent", tutorCancelled: false },
  { value: "Not Selected by Parent", tutorCancelled: true },
  { value: "Tutor Not Interested", tutorCancelled: true },
  { value: "Scheduling Issue", tutorCancelled: false },
  { value: "Location Issue", tutorCancelled: true },
  { value: "Other", tutorCancelled: false },
];

export default function CancelDemoModal({ setCancelDemo, onClick, item }) {
  const [data, setData] = useState({
    demoId: item._id,
    cancellationReason: "",
    tutorCancelled: false,
  });

  const onReasonChange = (e) => {
    const value = e.target.value;
    const option = CANCELLATION_REASONS.find((r) => r.value === value);
    setData((prev) => ({
      ...prev,
      cancellationReason: value,
      tutorCancelled: option ? option.tutorCancelled : false,
    }));
  };

  return (
    <Modal title="Cancel Demo" size="md">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onClick(e, data);
        }}
      >
        <div className="modal-inner-content">
          <div className="input-group">
            <label>Reason for Cancellation*</label>
            <select
              className="text-input"
              required
              value={data.cancellationReason}
              onChange={onReasonChange}
            >
              <option value="">Select reason</option>
              {CANCELLATION_REASONS.map((reason) => (
                <option key={reason.value} value={reason.value}>
                  {reason.value}
                </option>
              ))}
            </select>
          </div>
          <div className="checkbox-input-group">
            <input
              id="tutorCancelled"
              type="checkbox"
              checked={data.tutorCancelled}
              disabled
              readOnly
            />
            <label htmlFor="tutorCancelled">Tutor Mistake</label>
          </div>
        </div>
        <div className="modal-footer">
          <input
            type="button"
            className="xs-neutral-btn"
            onClick={() => setCancelDemo(false)}
            value="Cancel"
          />
          <input
            type="submit"
            className="xs-delete-btn"
            value="Cancel Demo"
            disabled={!data.cancellationReason}
          />
        </div>
      </form>
    </Modal>
  );
}
